var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFederal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 67.8 68",
    style: {
      enableBackground: "new 0 0 67.8 68"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_2_);}\r\n\t.st2{fill:url(#SVGID_3_);}\r\n\t.st3{fill:url(#SVGID_4_);}\r\n\t.st4{fill:url(#SVGID_5_);}\r\n\t.st5{fill:url(#SVGID_6_);}\r\n\t.st6{fill:url(#SVGID_7_);}\r\n\t.st7{fill:url(#SVGID_8_);}\r\n\t.st8{fill:url(#SVGID_9_);}\r\n\t.st9{fill:url(#SVGID_10_);}\r\n\t.st10{fill:url(#SVGID_11_);}\r\n\t.st11{fill:url(#SVGID_12_);}\r\n\t.st12{fill:url(#SVGID_13_);}\r\n\t.st13{fill:url(#SVGID_14_);}\r\n\t.st14{fill:url(#SVGID_15_);}\r\n\t.st15{fill:url(#SVGID_16_);}\r\n\t.st16{fill:url(#SVGID_17_);}\r\n\t.st17{fill:url(#SVGID_18_);}\r\n\t.st18{fill:url(#SVGID_19_);}\r\n\t.st19{fill:url(#SVGID_20_);}\r\n\t.st20{fill:url(#SVGID_21_);}\r\n\t.st21{fill:url(#SVGID_22_);}\r\n\t.st22{fill:url(#SVGID_23_);}\r\n\t.st23{fill:url(#SVGID_24_);}\r\n\t.st24{fill:url(#SVGID_25_);}\r\n\t.st25{fill:url(#SVGID_26_);}\r\n\t.st26{fill:url(#SVGID_27_);}\r\n\t.st27{fill:url(#SVGID_28_);}\r\n\t.st28{fill:url(#SVGID_29_);}\r\n\t.st29{fill:url(#SVGID_30_);}\r\n\t.st30{fill:url(#SVGID_31_);}\r\n\t.st31{fill:url(#SVGID_32_);}\r\n\t.st32{fill:url(#SVGID_33_);}\r\n\t.st33{fill:url(#SVGID_34_);}\r\n\t.st34{fill:url(#SVGID_35_);}\r\n\t.st35{fill:url(#SVGID_36_);}\r\n\t.st36{fill:url(#SVGID_37_);}\r\n\t.st37{fill:url(#SVGID_38_);}\r\n\t.st38{fill:url(#SVGID_39_);}\r\n\t.st39{fill:url(#SVGID_40_);}\r\n\t.st40{fill:url(#SVGID_41_);}\r\n\t.st41{fill:url(#SVGID_42_);}\r\n\t.st42{fill:url(#SVGID_43_);}\r\n\t.st43{fill:url(#SVGID_44_);}\r\n\t.st44{fill:url(#SVGID_45_);}\r\n\t.st45{fill:url(#SVGID_46_);}\r\n\t.st46{fill:url(#SVGID_47_);}\r\n\t.st47{fill:url(#SVGID_48_);}\r\n\t.st48{fill:url(#SVGID_49_);}\r\n\t.st49{fill:url(#SVGID_50_);}\r\n\t.st50{fill:url(#SVGID_51_);}\r\n\t.st51{fill:url(#SVGID_52_);}\r\n\t.st52{fill:url(#SVGID_53_);}\r\n\t.st53{fill:url(#SVGID_54_);}\r\n\t.st54{fill:url(#SVGID_55_);}\r\n\t.st55{fill:url(#SVGID_56_);}\r\n\t.st56{fill:url(#SVGID_57_);}\r\n\t.st57{fill:url(#SVGID_58_);}\r\n\t.st58{fill:url(#SVGID_59_);}\r\n\t.st59{fill:url(#SVGID_60_);}\r\n\t.st60{fill:url(#SVGID_61_);}\r\n\t.st61{fill:url(#SVGID_62_);}\r\n\t.st62{fill:url(#SVGID_63_);}\r\n\t.st63{fill:url(#SVGID_64_);}\r\n\t.st64{fill:url(#SVGID_65_);}\r\n\t.st65{fill:url(#SVGID_66_);}\r\n\t.st66{fill:url(#SVGID_67_);}\r\n\t.st67{fill:url(#SVGID_68_);}\r\n\t.st68{fill:url(#SVGID_69_);}\r\n\t.st69{fill:url(#SVGID_70_);}\r\n\t.st70{fill:url(#SVGID_71_);}\r\n\t.st71{fill:url(#SVGID_72_);}\r\n\t.st72{fill:url(#SVGID_73_);}\r\n\t.st73{fill:url(#SVGID_74_);}\r\n\t.st74{fill:url(#SVGID_75_);}\r\n\t.st75{fill:url(#SVGID_76_);}\r\n\t.st76{fill:url(#SVGID_77_);}\r\n\t.st77{fill:url(#SVGID_78_);}\r\n\t.st78{fill:url(#SVGID_79_);}\r\n\t.st79{fill:url(#SVGID_80_);}\r\n\t.st80{fill:url(#SVGID_81_);}\r\n\t.st81{fill:url(#SVGID_82_);}\r\n\t.st82{fill:url(#SVGID_83_);}\r\n\t.st83{fill:url(#SVGID_84_);}\r\n\t.st84{fill:url(#SVGID_85_);}\r\n\t.st85{fill:url(#SVGID_86_);}\r\n\t.st86{fill:url(#SVGID_87_);}\r\n\t.st87{fill:url(#SVGID_88_);}\r\n\t.st88{fill:url(#SVGID_89_);}\r\n\t.st89{fill:url(#SVGID_90_);}\r\n\t.st90{fill:url(#SVGID_91_);}\r\n\t.st91{fill:url(#SVGID_92_);}\r\n\t.st92{fill:url(#SVGID_93_);}\r\n\t.st93{fill:url(#SVGID_94_);}\r\n\t.st94{fill:url(#SVGID_95_);}\r\n\t.st95{fill:url(#SVGID_96_);}\r\n\t.st96{fill:url(#SVGID_97_);}\r\n\t.st97{fill:url(#SVGID_98_);}\r\n\t.st98{fill:url(#SVGID_99_);}\r\n\t.st99{fill:url(#SVGID_100_);}\r\n\t.st100{fill:url(#SVGID_101_);}\r\n\t.st101{fill:url(#SVGID_102_);}\r\n\t.st102{fill:url(#SVGID_103_);}\r\n\t.st103{fill:url(#SVGID_104_);}\r\n\t.st104{fill:url(#SVGID_105_);}\r\n\t.st105{fill:url(#SVGID_106_);}\r\n\t.st106{fill:url(#SVGID_107_);}\r\n\t.st107{fill:url(#SVGID_108_);}\r\n\t.st108{fill:url(#SVGID_109_);}\r\n\t.st109{fill:url(#SVGID_110_);}\r\n\t.st110{fill:url(#SVGID_111_);}\r\n\t.st111{fill:url(#SVGID_112_);}\r\n\t.st112{fill:url(#SVGID_113_);}\r\n\t.st113{fill:#00833E;}\r\n\t.st114{fill:url(#SVGID_114_);}\r\n\t.st115{fill:url(#SVGID_115_);}\r\n\t.st116{fill:url(#SVGID_116_);}\r\n\t.st117{fill:url(#SVGID_117_);}\r\n\t.st118{fill:url(#SVGID_118_);}\r\n\t.st119{fill:url(#SVGID_119_);}\r\n\t.st120{fill:url(#SVGID_120_);}\r\n\t.st121{fill:url(#SVGID_121_);}\r\n\t.st122{fill:url(#SVGID_122_);}\r\n\t.st123{fill:url(#SVGID_123_);}\r\n\t.st124{fill:url(#SVGID_124_);}\r\n\t.st125{fill:url(#SVGID_125_);}\r\n\t.st126{fill:url(#SVGID_126_);}\r\n\t.st127{fill:url(#SVGID_127_);}\r\n\t.st128{fill:url(#SVGID_128_);}\r\n\t.st129{fill:url(#SVGID_129_);}\r\n\t.st130{fill:url(#SVGID_130_);}\r\n\t.st131{fill:url(#SVGID_131_);}\r\n\t.st132{fill:url(#SVGID_132_);}\r\n\t.st133{fill:url(#SVGID_133_);}\r\n\t.st134{fill:url(#SVGID_134_);}\r\n\t.st135{fill:url(#SVGID_135_);}\r\n\t.st136{fill:url(#SVGID_136_);}\r\n\t.st137{fill:url(#SVGID_137_);}\r\n\t.st138{fill:url(#SVGID_138_);}\r\n\t.st139{fill:url(#SVGID_139_);}\r\n\t.st140{fill:url(#SVGID_140_);}\r\n\t.st141{fill:url(#SVGID_141_);}\r\n\t.st142{fill:url(#SVGID_142_);}\r\n\t.st143{fill:url(#SVGID_143_);}\r\n\t.st144{fill:url(#SVGID_144_);}\r\n\t.st145{fill:url(#SVGID_145_);}\r\n\t.st146{fill:url(#SVGID_146_);}\r\n\t.st147{fill:url(#SVGID_147_);}\r\n\t.st148{fill:url(#SVGID_148_);}\r\n\t.st149{fill:url(#SVGID_149_);}\r\n\t.st150{fill:url(#SVGID_150_);}\r\n\t.st151{fill:url(#SVGID_151_);}\r\n\t.st152{fill:url(#SVGID_152_);}\r\n\t.st153{fill:url(#SVGID_153_);}\r\n\t.st154{fill:url(#SVGID_154_);}\r\n\t.st155{fill:url(#SVGID_155_);}\r\n\t.st156{fill:url(#SVGID_156_);}\r\n\t.st157{fill:url(#SVGID_157_);}\r\n\t.st158{fill:url(#SVGID_158_);}\r\n\t.st159{fill:url(#SVGID_159_);}\r\n\t.st160{fill:url(#SVGID_160_);}\r\n\t.st161{fill:url(#SVGID_161_);}\r\n\t.st162{fill:url(#SVGID_162_);}\r\n\t.st163{fill:url(#SVGID_163_);}\r\n\t.st164{fill:url(#SVGID_164_);}\r\n\t.st165{fill:url(#SVGID_165_);}\r\n\t.st166{fill:url(#SVGID_166_);}\r\n\t.st167{fill:url(#SVGID_167_);}\r\n\t.st168{fill:url(#SVGID_168_);}\r\n\t.st169{fill:url(#SVGID_169_);}\r\n\t.st170{fill:url(#SVGID_170_);}\r\n\t.st171{fill:url(#SVGID_171_);}\r\n\t.st172{fill:url(#SVGID_172_);}\r\n\t.st173{fill:url(#SVGID_173_);}\r\n\t.st174{fill:url(#SVGID_174_);}\r\n\t.st175{fill:url(#SVGID_175_);}\r\n\t.st176{fill:url(#SVGID_176_);}\r\n\t.st177{fill:url(#SVGID_177_);}\r\n\t.st178{fill:url(#SVGID_178_);}\r\n\t.st179{fill:url(#SVGID_179_);}\r\n\t.st180{fill:url(#SVGID_180_);}\r\n\t.st181{fill:url(#SVGID_181_);}\r\n\t.st182{fill:url(#SVGID_182_);}\r\n\t.st183{fill:url(#SVGID_183_);}\r\n\t.st184{fill:url(#SVGID_184_);}\r\n\t.st185{fill:url(#SVGID_185_);}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.467,
    y1: 32.7886,
    x2: 52.9655,
    y2: 32.7886
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.5,33c0.5,0,1.2,0.2,1.2,0.6c0.2-0.2,0.5-0.6-0.2-1.1c-1.4-1.1-3.9-1.5-6.1-1.7c0.8,0.3,1.5,0.6,2.4,1.2 c-1.2,1.6,1.1,3.2,2,1.6c-0.5,1.5-3.1,0.8-2.9-1.3C47.2,34.8,51.1,36.2,51.5,33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.0363,
    y1: 35.8113,
    x2: 55.14,
    y2: 35.8113
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.6,36.3c0.3,0,0.5-0.1,0.6-0.3c0.1-0.2-0.1-0.5-0.4-0.6c-0.3-0.1-0.6,0.1-0.7,0.3c0,0,0.1,0,0.2,0 c0.3,0.1,0.5,0.3,0.4,0.5C54.6,36.2,54.6,36.3,54.6,36.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6,38.9C29.4,39.1,29.5,39,29.6,38.9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2,39.8C31.1,39.8,31.1,39.8,31.2,39.8C30.6,40.4,31,40,31.2,39.8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.592,
    y1: 39.9958,
    x2: 67.75,
    y2: 39.9958
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M62.3,51.2c-6.4,0.5-10.9-1.5-12.5-3.5c-1.6-1.7-1.7-3.8-1.3-5.1c0.1-0.5,0.2-0.7,1.2-1.8 c0.7-0.8,2.1-1.4,2.7-1.8c0.8,0.6,2.4,0.7,3.2,0.8c0.1,0.4-0.1,0.7-0.4,1.4c1.2-0.5,1.7-1.8,1.9-2.4c0.1-0.6,0.3-2.1-1.2-3.5 c-0.5-0.4-1-2.4-1.5-3.1c-0.6-0.8-5.8-6.4-12.2-4.3c-5.8,1.9-9.1,7-12.3,10.6c-0.1,0.1-0.2,0.2-0.3,0.3l0.8,0.9 c0.8-0.3,0.9-0.2,0.8,0c1-1,3.5-4,4.5-5.1c2.7-2.8,6-4.1,8.6-4.3c-1.8-0.3-2.8-0.2-3.9-0.1c3.7-2.4,8.8-2.2,13.1,2 c1.4,1.4,1,2.1,1.6,2.6c1.7,1.6,1.4,3,0.8,3.8c-0.1-0.2-1-0.4-1.8-1.2c-0.4-0.2-3.1-0.4-5,0.7c-1,0.7-1.8,2-2.1,3 c-0.4,1.6-1,4.1,2.5,7.9c0,0,3.5,4.1,12.1,3.5c2.4-0.2,3.2-1,5-1.9l1.2-0.7C66.1,50.2,64.5,51,62.3,51.2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3,38.5l0.3,0.4C29.8,38.6,30,38.2,29.3,38.5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6,38.9C29.6,38.9,29.6,38.9,29.6,38.9L29.6,38.9C29.6,38.9,29.6,38.9,29.6,38.9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.5774,
    y1: 31.3783,
    x2: 37.6205,
    y2: 31.3783
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M13.4,2.9c0.2,0.7,0.4,1.5,0.6,2.2c1,3.9,2,7.9,3.3,11.7c2.8,8.2,7.9,16,16.2,24.3l0.2,0.2c0.5,0.5,1,1,1.4,1.4 c3.4,4,3.4,4.3,0.1,8.3c-2.2,2.6-3.4,5.6-3.6,8.7c-0.3-3.4,0.5-6.7,2.6-10.1c2-3.3,1.6-5.1-1.3-7.6C25.3,35.7,20,29.6,16,23.1 c-2.5-4.2-5-9.3-4.3-15.3C12,6,12.5,4.3,13.4,2.9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.7992,
    y1: 49.8078,
    x2: 22.8174,
    y2: 49.8078
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M22.2,50.3c-0.3-0.1-0.4-0.4-0.4-0.6c0.1-0.3,0.4-0.4,0.6-0.4c0.3,0.1,0.4,0.4,0.4,0.6 C22.7,50.2,22.4,50.4,22.2,50.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.3004,
    y1: 53.0804,
    x2: 17.3185,
    y2: 53.0804
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M16.7,53.6c-0.3-0.1-0.4-0.4-0.4-0.6c0.1-0.3,0.4-0.4,0.6-0.4c0.3,0.1,0.4,0.4,0.4,0.6 C17.2,53.5,16.9,53.6,16.7,53.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.9015,
    y1: 54.3049,
    x2: 17.9196,
    y2: 54.3049
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M17.3,54.8c-0.3-0.1-0.4-0.4-0.4-0.6c0.1-0.3,0.4-0.4,0.6-0.4c0.3,0.1,0.4,0.4,0.4,0.6 C17.8,54.7,17.5,54.9,17.3,54.8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.1036,
    y1: 56.2233,
    x2: 19.1218,
    y2: 56.2233
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M18.5,56.7c-0.3-0.1-0.4-0.4-0.4-0.6c0.1-0.3,0.4-0.4,0.6-0.4c0.3,0.1,0.4,0.4,0.4,0.6 C19,56.6,18.8,56.8,18.5,56.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.378,
    y1: 51.2326,
    x2: 23.3962,
    y2: 51.2326
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M22.8,51.7c-0.3-0.1-0.4-0.4-0.4-0.6c0.1-0.3,0.4-0.4,0.6-0.4c0.3,0.1,0.4,0.4,0.4,0.6S23,51.8,22.8,51.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.2908,
    y1: 52.6352,
    x2: 24.3089,
    y2: 52.6352
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M23.7,53.1c-0.3-0.1-0.4-0.4-0.4-0.6c0.1-0.3,0.4-0.4,0.6-0.4c0.3,0.1,0.4,0.4,0.4,0.6S23.9,53.2,23.7,53.1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.3465,
    y1: 50.6754,
    x2: 21.6876,
    y2: 50.6754
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M20.8,51.3c-0.4-0.1-0.6-0.5-0.5-0.8c0.1-0.4,0.5-0.6,0.8-0.5c0.4,0.1,0.6,0.5,0.5,0.8 C21.6,51.2,21.2,51.4,20.8,51.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.8104,
    y1: 51.522,
    x2: 20.1593,
    y2: 51.522
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M19.3,52.2c-0.4-0.1-0.6-0.5-0.5-0.8c0.1-0.4,0.5-0.6,0.8-0.5c0.4,0.1,0.6,0.5,0.5,0.8S19.7,52.3,19.3,52.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.4154,
    y1: 52.3349,
    x2: 18.586,
    y2: 52.3349
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M17.9,52.9c-0.3-0.1-0.5-0.4-0.4-0.7c0.1-0.3,0.4-0.5,0.7-0.4c0.3,0.1,0.5,0.4,0.4,0.7 C18.5,52.8,18.2,53,17.9,52.9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.0165,
    y1: 53.6742,
    x2: 19.1871,
    y2: 53.6742
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M18.5,54.2c-0.3-0.1-0.5-0.4-0.4-0.7c0.1-0.3,0.4-0.5,0.7-0.4c0.3,0.1,0.5,0.4,0.4,0.7 C19.1,54.1,18.8,54.3,18.5,54.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.7957,
    y1: 54.8542,
    x2: 19.9663,
    y2: 54.8542
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M19.2,55.4c-0.3-0.1-0.5-0.4-0.4-0.7c0.1-0.3,0.4-0.5,0.7-0.4c0.3,0.1,0.5,0.4,0.4,0.7 C19.9,55.3,19.6,55.5,19.2,55.4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.6194,
    y1: 56.0349,
    x2: 20.79,
    y2: 56.0349
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M20.1,56.6c-0.3-0.1-0.5-0.4-0.4-0.7c0.1-0.3,0.4-0.5,0.7-0.4c0.3,0.1,0.5,0.4,0.4,0.7 C20.7,56.5,20.4,56.7,20.1,56.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.5544,
    y1: 57.0359,
    x2: 21.725,
    y2: 57.0359
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M21,57.6c-0.3-0.1-0.5-0.4-0.4-0.7s0.4-0.5,0.7-0.4c0.3,0.1,0.5,0.4,0.4,0.7C21.6,57.5,21.3,57.7,21,57.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.4337,
    y1: 52.8794,
    x2: 20.7826,
    y2: 52.8794
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M19.9,53.5c-0.4-0.1-0.6-0.5-0.5-0.8c0.1-0.4,0.5-0.6,0.8-0.5c0.4,0.1,0.6,0.5,0.5,0.8 C20.7,53.4,20.3,53.6,19.9,53.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.2129,
    y1: 54.1713,
    x2: 21.5618,
    y2: 54.1713
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M20.7,54.8c-0.4-0.1-0.6-0.5-0.5-0.8c0.1-0.4,0.5-0.6,0.8-0.5c0.4,0.1,0.6,0.5,0.5,0.8 C21.4,54.7,21.1,54.9,20.7,54.8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.2147,
    y1: 55.3728,
    x2: 22.5636,
    y2: 55.3728
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M21.7,56c-0.4-0.1-0.6-0.5-0.5-0.8c0.1-0.4,0.5-0.6,0.8-0.5c0.4,0.1,0.6,0.5,0.5,0.8 C22.4,55.9,22.1,56.1,21.7,56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.0589,
    y1: 52.256,
    x2: 22.4,
    y2: 52.256
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M21.6,52.9c-0.4-0.1-0.6-0.5-0.5-0.8c0.1-0.4,0.5-0.6,0.8-0.5c0.4,0.1,0.6,0.5,0.5,0.8 C22.3,52.8,21.9,53,21.6,52.9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.1052,
    y1: 53.7928,
    x2: 23.4463,
    y2: 53.7928
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M22.6,54.4c-0.4-0.1-0.6-0.5-0.5-0.8c0.1-0.4,0.5-0.6,0.8-0.5c0.4,0.1,0.6,0.5,0.5,0.8S23,54.5,22.6,54.4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.7993,
    y1: 47.6707,
    x2: 28.268,
    y2: 47.6707
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M28,47.9c-0.1,0-0.2-0.2-0.2-0.3c0-0.1,0.2-0.2,0.3-0.2c0.1,0,0.2,0.2,0.2,0.3C28.2,47.9,28.1,47.9,28,47.9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.8644,
    y1: 47.9194,
    x2: 27.3773,
    y2: 47.9194
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M27.1,48.2c-0.1,0-0.2-0.2-0.2-0.3c0-0.1,0.2-0.2,0.3-0.2c0.1,0,0.2,0.2,0.2,0.3 C27.3,48.1,27.2,48.2,27.1,48.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.974,
    y1: 48.1754,
    x2: 26.5535,
    y2: 48.1754
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M26.2,48.5c-0.2,0-0.2-0.2-0.2-0.4c0-0.2,0.2-0.2,0.4-0.2c0.2,0,0.2,0.2,0.2,0.4 C26.5,48.4,26.3,48.5,26.2,48.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.2862,
    y1: 54.6093,
    x2: 14.8657,
    y2: 54.6093
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M14.5,54.9c-0.2,0-0.2-0.2-0.2-0.4c0-0.2,0.2-0.2,0.4-0.2c0.2,0,0.2,0.2,0.2,0.4 C14.8,54.8,14.7,54.9,14.5,54.9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.3065,
    y1: 55.4627,
    x2: 13.8194,
    y2: 55.4627
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M13.5,55.7c-0.1,0-0.2-0.2-0.2-0.3c0-0.1,0.2-0.2,0.3-0.2c0.1,0,0.2,0.2,0.2,0.3 C13.8,55.7,13.6,55.7,13.5,55.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.774,
    y1: 56.3755,
    x2: 14.287,
    y2: 56.3755
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M14,56.6c-0.1,0-0.2-0.2-0.2-0.3c0-0.1,0.2-0.2,0.3-0.2c0.1,0,0.2,0.2,0.2,0.3C14.2,56.6,14.1,56.6,14,56.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.8205,
    y1: 55.7217,
    x2: 15.4,
    y2: 55.7217
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M15,56c-0.2,0-0.2-0.2-0.2-0.4c0-0.2,0.2-0.2,0.4-0.2c0.2,0,0.2,0.2,0.2,0.4C15.3,55.9,15.2,56,15,56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.0852,
    y1: 48.4759,
    x2: 25.7727,
    y2: 48.4759
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M25.3,48.8c-0.2,0-0.3-0.2-0.2-0.4c0-0.2,0.2-0.3,0.4-0.2c0.2,0,0.3,0.2,0.2,0.4 C25.7,48.7,25.5,48.9,25.3,48.8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.1502,
    y1: 48.7988,
    x2: 24.9044,
    y2: 48.7988
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M24.4,49.2c-0.2,0-0.3-0.3-0.3-0.5s0.3-0.3,0.5-0.3s0.3,0.3,0.3,0.5C24.8,49.1,24.6,49.2,24.4,49.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.2674,
    y1: 53.7856,
    x2: 16.0216,
    y2: 53.7856
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M15.5,54.2c-0.2,0-0.3-0.3-0.3-0.5c0-0.2,0.3-0.3,0.5-0.3s0.3,0.3,0.3,0.5C15.9,54.1,15.7,54.2,15.5,54.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.9131,
    y1: 55.099,
    x2: 16.6672,
    y2: 55.099
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M16.2,55.5c-0.2,0-0.3-0.3-0.3-0.5c0-0.2,0.3-0.3,0.5-0.3s0.3,0.3,0.3,0.5C16.6,55.4,16.4,55.5,16.2,55.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.9938,
    y1: 49.2781,
    x2: 23.8958,
    y2: 49.2781
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M23.3,49.7c-0.2-0.1-0.4-0.3-0.3-0.6c0.1-0.2,0.3-0.4,0.6-0.3c0.2,0.1,0.4,0.3,0.3,0.6 C23.8,49.7,23.6,49.8,23.3,49.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.4836,
    y1: 50.4573,
    x2: 24.3981,
    y2: 50.4573
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M23.8,50.9c-0.2-0.1-0.4-0.3-0.3-0.6c0.1-0.2,0.3-0.4,0.6-0.3c0.2,0.1,0.4,0.3,0.3,0.6 C24.3,50.8,24.1,51,23.8,50.9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.196,
    y1: 51.6817,
    x2: 25.1105,
    y2: 51.6817
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M24.5,52.1c-0.2-0.1-0.4-0.3-0.3-0.6c0.1-0.2,0.3-0.4,0.6-0.3c0.2,0.1,0.4,0.3,0.3,0.6 C25.1,52,24.8,52.2,24.5,52.1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.5287,
    y1: 49.8451,
    x2: 25.2828,
    y2: 49.8451
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M24.8,50.2c-0.2,0-0.3-0.3-0.3-0.5c0-0.2,0.3-0.3,0.5-0.3c0.2,0,0.3,0.3,0.3,0.5C25.2,50.1,25,50.3,24.8,50.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.1298,
    y1: 50.8952,
    x2: 25.8839,
    y2: 50.8952
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M25.4,51.3c-0.2,0-0.3-0.3-0.3-0.5c0-0.2,0.3-0.3,0.5-0.3s0.3,0.3,0.3,0.5C25.8,51.2,25.6,51.3,25.4,51.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.3746,
    y1: 49.3672,
    x2: 26.0621,
    y2: 49.3672
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M25.6,49.7c-0.2,0-0.3-0.2-0.2-0.4c0-0.2,0.2-0.3,0.4-0.2c0.2,0,0.3,0.2,0.2,0.4C26,49.7,25.8,49.7,25.6,49.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.8421,
    y1: 50.2347,
    x2: 26.5296,
    y2: 50.2347
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M26.1,50.6c-0.2,0-0.3-0.2-0.2-0.4c0-0.2,0.2-0.3,0.4-0.2s0.3,0.2,0.2,0.4C26.5,50.5,26.3,50.6,26.1,50.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.2412,
    y1: 48.9538,
    x2: 26.8207,
    y2: 48.9538
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M26.5,49.2c-0.2,0-0.2-0.2-0.2-0.4c0-0.2,0.2-0.2,0.4-0.2c0.2,0,0.2,0.2,0.2,0.4 C26.8,49.2,26.6,49.3,26.5,49.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.5974,
    y1: 49.6662,
    x2: 27.1768,
    y2: 49.6662
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M26.8,49.9c-0.2,0-0.2-0.2-0.2-0.4c0-0.2,0.2-0.2,0.4-0.2c0.2,0,0.2,0.2,0.2,0.4C27.1,49.9,27,50,26.8,49.9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.3319,
    y1: 49.0993,
    x2: 27.8448,
    y2: 49.0993
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M27.5,49.3c-0.1,0-0.2-0.2-0.2-0.3c0-0.1,0.2-0.2,0.3-0.2c0.1,0,0.2,0.2,0.2,0.3 C27.8,49.3,27.7,49.4,27.5,49.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.0648,
    y1: 48.5205,
    x2: 27.5777,
    y2: 48.5205
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M27.3,48.8c-0.1,0-0.2-0.2-0.2-0.3c0-0.1,0.2-0.2,0.3-0.2c0.1,0,0.2,0.2,0.2,0.3 C27.5,48.7,27.4,48.8,27.3,48.8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.111,
    y1: 48.5167,
    x2: 28.5796,
    y2: 48.5167
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M28.3,48.7c-0.1,0-0.2-0.2-0.2-0.3c0-0.1,0.2-0.2,0.3-0.2c0.1,0,0.2,0.2,0.2,0.3 C28.5,48.7,28.4,48.8,28.3,48.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.7405,
    y1: 47.4624,
    x2: 29.1301,
    y2: 47.4624
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M28.9,47.7c-0.1,0-0.2-0.1-0.1-0.2c0-0.1,0.1-0.2,0.2-0.1s0.2,0.1,0.1,0.2C29.1,47.6,29,47.7,28.9,47.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.4665,
    y1: 56.3235,
    x2: 12.8561,
    y2: 56.3235
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M12.6,56.5c-0.1,0-0.2-0.1-0.1-0.2c0-0.1,0.1-0.2,0.2-0.1s0.2,0.1,0.1,0.2C12.8,56.5,12.7,56.5,12.6,56.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.9408,
    y1: 47.9973,
    x2: 29.3304,
    y2: 47.9973
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M29.1,48.2c-0.1,0-0.2-0.1-0.1-0.2c0-0.1,0.1-0.2,0.2-0.1c0.1,0,0.2,0.1,0.1,0.2 C29.3,48.2,29.2,48.2,29.1,48.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.4157,
    y1: 47.1555,
    x2: 30.558,
    y2: 47.1555
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M30.5,47.2C30.4,47.2,30.4,47.2,30.5,47.2c0-0.1,0-0.2,0-0.2C30.5,47.1,30.6,47.1,30.5,47.2 C30.6,47.2,30.5,47.3,30.5,47.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.6307,
    y1: 47.2597,
    x2: 29.8872,
    y2: 47.2597
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M29.7,47.4c-0.1,0-0.1-0.1-0.1-0.2c0-0.1,0.1-0.1,0.2-0.1c0.1,0,0.1,0.1,0.1,0.2 C29.9,47.4,29.8,47.4,29.7,47.4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.7421,
    y1: 47.5966,
    x2: 29.9985,
    y2: 47.5966
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M29.8,47.7c-0.1,0-0.1-0.1-0.1-0.2s0.1-0.1,0.2-0.1c0.1,0,0.1,0.1,0.1,0.2C30,47.7,29.9,47.7,29.8,47.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.8464,
    y1: 42.3983,
    x2: 18.2051,
    y2: 42.3983
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M17,42.9c-0.3-0.3-0.2-0.7,0-1c0.3-0.3,0.7-0.2,1,0c0.3,0.3,0.2,0.7,0,1C17.7,43.2,17.3,43.1,17,42.9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.735,
    y1: 44.2751,
    x2: 18.0938,
    y2: 44.2751
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M16.9,44.7c-0.3-0.3-0.2-0.7,0-1c0.3-0.3,0.7-0.2,1,0c0.3,0.3,0.2,0.7,0,1S17.2,45,16.9,44.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.6237,
    y1: 46.0116,
    x2: 17.9824,
    y2: 46.0116
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M16.8,46.5c-0.3-0.3-0.2-0.7,0-1c0.3-0.3,0.7-0.2,1,0c0.3,0.3,0.2,0.7,0,1C17.5,46.8,17.1,46.8,16.8,46.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.6496,
    y1: 44.8026,
    x2: 20.0083,
    y2: 44.8026
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M18.8,45.3c-0.3-0.3-0.2-0.7,0-1c0.3-0.3,0.7-0.2,1,0c0.3,0.3,0.2,0.7,0,1C19.5,45.6,19.1,45.5,18.8,45.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.6719,
    y1: 47.0552,
    x2: 20.0306,
    y2: 47.0552
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M18.9,47.5c-0.3-0.3-0.2-0.7,0-1c0.3-0.3,0.7-0.2,1,0c0.3,0.3,0.2,0.7,0,1C19.6,47.8,19.1,47.8,18.9,47.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.9836,
    y1: 42.5541,
    x2: 20.3423,
    y2: 42.5541
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M19.2,43c-0.3-0.3-0.2-0.7,0-1c0.3-0.3,0.7-0.2,1,0c0.3,0.3,0.2,0.7,0,1C19.9,43.3,19.4,43.3,19.2,43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.3832,
    y1: 44.4977,
    x2: 15.9263,
    y2: 44.4977
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M14.6,45c-0.3-0.3-0.3-0.8,0-1.1c0.3-0.3,0.8-0.3,1.1,0c0.3,0.3,0.3,0.8,0,1.1C15.4,45.3,14.9,45.3,14.6,45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.5613,
    y1: 42.1868,
    x2: 16.1044,
    y2: 42.1868
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M14.8,42.7c-0.3-0.3-0.3-0.8,0-1.1c0.3-0.3,0.8-0.3,1.1,0c0.3,0.3,0.3,0.8,0,1.1C15.5,43,15.1,43,14.8,42.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.3832,
    y1: 46.5904,
    x2: 15.9263,
    y2: 46.5904
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M14.6,47.1c-0.3-0.3-0.3-0.8,0-1.1c0.3-0.3,0.8-0.3,1.1,0c0.3,0.3,0.3,0.8,0,1.1 C15.4,47.4,14.9,47.4,14.6,47.1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.6281,
    y1: 48.7542,
    x2: 16.1712,
    y2: 48.7542
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M14.8,49.3c-0.3-0.3-0.3-0.8,0-1.1c0.3-0.3,0.8-0.3,1.1,0c0.3,0.3,0.3,0.8,0,1.1 C15.6,49.6,15.1,49.6,14.8,49.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.7128,
    y1: 47.8109,
    x2: 18.0715,
    y2: 47.8109
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M16.9,48.3c-0.3-0.3-0.2-0.7,0-1c0.3-0.3,0.7-0.2,1,0c0.3,0.3,0.2,0.7,0,1C17.6,48.6,17.2,48.5,16.9,48.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.7055,
    y1: 50.1902,
    x2: 14.0642,
    y2: 50.1902
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M12.9,50.7c-0.3-0.3-0.2-0.7,0-1c0.3-0.3,0.7-0.2,1,0c0.3,0.3,0.2,0.7,0,1C13.6,50.9,13.1,50.9,12.9,50.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.3716,
    y1: 48.2978,
    x2: 13.7303,
    y2: 48.2978
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M12.6,48.8c-0.3-0.3-0.2-0.7,0-1c0.3-0.3,0.7-0.2,1,0c0.3,0.3,0.2,0.7,0,1C13.3,49.1,12.8,49,12.6,48.8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.1676,
    y1: 47.5632,
    x2: 11.5263,
    y2: 47.5632
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M10.4,48c-0.3-0.3-0.2-0.7,0-1c0.3-0.3,0.7-0.2,1,0c0.3,0.3,0.2,0.7,0,1C11,48.3,10.6,48.3,10.4,48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.1676,
    y1: 44.2306,
    x2: 11.5263,
    y2: 44.2306
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M10.4,44.7c-0.3-0.3-0.2-0.7,0-1c0.3-0.3,0.7-0.2,1,0c0.3,0.3,0.2,0.7,0,1S10.6,45,10.4,44.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_67_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.3457,
    y1: 42.2424,
    x2: 11.7044,
    y2: 42.2424
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M10.5,42.7c-0.3-0.3-0.2-0.7,0-1c0.3-0.3,0.7-0.2,1,0c0.3,0.3,0.2,0.7,0,1C11.2,43,10.8,43,10.5,42.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_68_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.3902,
    y1: 49.6154,
    x2: 11.7489,
    y2: 49.6154
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M10.6,50.1c-0.3-0.3-0.2-0.7,0-1c0.3-0.3,0.7-0.2,1,0c0.3,0.3,0.2,0.7,0,1C11.3,50.4,10.8,50.4,10.6,50.1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_69_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.9468,
    y1: 51.4842,
    x2: 12.3055,
    y2: 51.4842
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M11.1,51.9c-0.3-0.3-0.2-0.7,0-1c0.3-0.3,0.7-0.2,1,0c0.3,0.3,0.2,0.7,0,1C11.8,52.2,11.4,52.2,11.1,51.9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_70_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.2603,
    y1: 46.3193,
    x2: 13.619,
    y2: 46.3193
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M12.4,46.8c-0.3-0.3-0.2-0.7,0-1c0.3-0.3,0.7-0.2,1,0c0.3,0.3,0.2,0.7,0,1C13.1,47.1,12.7,47.1,12.4,46.8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_71_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.2603,
    y1: 44.3128,
    x2: 13.619,
    y2: 44.3128
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st70",
    d: "M12.4,44.8c-0.3-0.3-0.2-0.7,0-1c0.3-0.3,0.7-0.2,1,0c0.3,0.3,0.2,0.7,0,1C13.1,45.1,12.7,45,12.4,44.8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_72_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.4606,
    y1: 42.2898,
    x2: 13.8193,
    y2: 42.2898
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M12.7,42.8c-0.3-0.3-0.2-0.7,0-1c0.3-0.3,0.7-0.2,1,0c0.3,0.3,0.2,0.7,0,1C13.3,43,12.9,43,12.7,42.8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_73_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.9082,
    y1: 44.2668,
    x2: 28.5598,
    y2: 44.2668
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M28,44.5c-0.1-0.1-0.1-0.3,0-0.5c0.1-0.1,0.3-0.1,0.5,0c0.1,0.1,0.1,0.3,0,0.4C28.3,44.6,28.1,44.6,28,44.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_74_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.5781,
    y1: 43.8676,
    x2: 27.3075,
    y2: 43.8676
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st73",
    d: "M26.7,44.1c-0.1-0.2-0.1-0.4,0-0.5c0.2-0.1,0.4-0.1,0.5,0c0.1,0.2,0.1,0.4,0,0.5C27,44.3,26.8,44.3,26.7,44.1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_75_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.2924,
    y1: 43.5408,
    x2: 26.122,
    y2: 43.5408
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M25.4,43.8c-0.2-0.2-0.2-0.4,0-0.6c0.2-0.2,0.4-0.2,0.6,0c0.2,0.2,0.2,0.4,0,0.6C25.8,44,25.6,44,25.4,43.8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_76_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.7779,
    y1: 42.4094,
    x2: 7.5995,
    y2: 42.4094
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M6.9,42.7c-0.2-0.2-0.1-0.4,0-0.6c0.2-0.2,0.4-0.2,0.6,0c0.2,0.2,0.2,0.4,0,0.6C7.3,42.9,7,42.9,6.9,42.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_77_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.9611,
    y1: 42.6877,
    x2: 5.6905,
    y2: 42.6877
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M5.1,42.9c-0.1-0.2-0.1-0.4,0-0.5c0.2-0.1,0.4-0.1,0.5,0c0.1,0.2,0.1,0.4,0,0.5C5.4,43.1,5.2,43.1,5.1,42.9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_78_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.8276,
    y1: 44.1348,
    x2: 5.557,
    y2: 44.1348
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M4.9,44.4c-0.1-0.2-0.1-0.4,0-0.5c0.2-0.1,0.4-0.1,0.5,0c0.1,0.2,0.1,0.4,0,0.5C5.3,44.5,5.1,44.5,4.9,44.4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_79_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.5775,
    y1: 44.1598,
    x2: 7.3992,
    y2: 44.1598
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M6.7,44.4c-0.2-0.2-0.1-0.4,0-0.6c0.2-0.2,0.4-0.2,0.6,0c0.2,0.2,0.2,0.4,0,0.6C7.1,44.6,6.9,44.6,6.7,44.4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_80_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.3043,
    y1: 52.0936,
    x2: 8.1338,
    y2: 52.0936
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M7.4,52.4c-0.2-0.2-0.2-0.4,0-0.6c0.2-0.2,0.4-0.2,0.6,0c0.2,0.2,0.2,0.4,0,0.6C7.8,52.5,7.6,52.5,7.4,52.4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_81_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.9133,
    y1: 54.2225,
    x2: 8.7349,
    y2: 54.2225
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M8,54.5c-0.2-0.2-0.1-0.4,0-0.6c0.2-0.2,0.4-0.2,0.6,0c0.2,0.2,0.2,0.4,0,0.6C8.4,54.7,8.2,54.7,8,54.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_82_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.6016,
    y1: 53.2207,
    x2: 8.4233,
    y2: 53.2207
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M7.7,53.5c-0.2-0.2-0.1-0.4,0-0.6c0.2-0.2,0.4-0.2,0.6,0c0.2,0.2,0.2,0.4,0,0.6C8.1,53.7,7.9,53.7,7.7,53.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_83_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.9845,
    y1: 43.2709,
    x2: 24.9587,
    y2: 43.2709
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st82",
    d: "M24.1,43.6c-0.2-0.2-0.2-0.5,0-0.7s0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7C24.6,43.8,24.3,43.8,24.1,43.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_84_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.6178,
    y1: 42.9743,
    x2: 23.6842,
    y2: 42.9743
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M22.8,43.3c-0.2-0.2-0.2-0.6,0-0.8c0.2-0.2,0.6-0.2,0.8,0c0.2,0.2,0.2,0.6,0,0.8C23.3,43.6,23,43.6,22.8,43.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_85_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.5701,
    y1: 42.2353,
    x2: 9.6365,
    y2: 42.2353
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M8.7,42.6c-0.2-0.2-0.2-0.6,0-0.8c0.2-0.2,0.6-0.2,0.8,0c0.2,0.2,0.2,0.6,0,0.8C9.2,42.8,8.9,42.8,8.7,42.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_86_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.3698,
    y1: 44.3057,
    x2: 9.4362,
    y2: 44.3057
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M8.5,44.7c-0.2-0.2-0.2-0.6,0-0.8c0.2-0.2,0.6-0.2,0.8,0c0.2,0.2,0.2,0.6,0,0.8C9,44.9,8.7,44.9,8.5,44.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_87_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.5924,
    y1: 49.6936,
    x2: 9.6588,
    y2: 49.6936
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M8.7,50.1c-0.2-0.2-0.2-0.6,0-0.8c0.2-0.2,0.6-0.2,0.8,0s0.2,0.6,0,0.8C9.3,50.3,8.9,50.3,8.7,50.1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_88_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.9041,
    y1: 51.2922,
    x2: 9.9705,
    y2: 51.2922
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M9,51.7c-0.2-0.2-0.2-0.6,0-0.8c0.2-0.2,0.6-0.2,0.8,0c0.2,0.2,0.2,0.6,0,0.8C9.6,51.9,9.2,51.9,9,51.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_89_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.3493,
    y1: 52.8505,
    x2: 10.4157,
    y2: 52.8505
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M9.5,53.2c-0.2-0.2-0.2-0.6,0-0.8c0.2-0.2,0.6-0.2,0.8,0c0.2,0.2,0.2,0.6,0,0.8C10,53.4,9.7,53.4,9.5,53.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_90_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.8258,
    y1: 42.7528,
    x2: 22.1289,
    y2: 42.7528
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M21,43.2c-0.2-0.3-0.2-0.7,0-0.9c0.3-0.2,0.7-0.2,0.9,0c0.2,0.3,0.2,0.7,0,0.9C21.7,43.5,21.2,43.5,21,43.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_91_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.5363,
    y1: 44.5478,
    x2: 21.8395,
    y2: 44.5478
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st90",
    d: "M20.7,45c-0.2-0.3-0.2-0.7,0-0.9c0.3-0.2,0.7-0.2,0.9,0c0.2,0.3,0.2,0.7,0,0.9C21.4,45.3,21,45.2,20.7,45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_92_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.4918,
    y1: 46.5777,
    x2: 21.7926,
    y2: 46.5777
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M20.7,47c-0.2-0.3-0.2-0.7,0-0.9c0.3-0.2,0.7-0.2,0.9,0c0.2,0.3,0.2,0.7,0,0.9C21.3,47.3,20.9,47.3,20.7,47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_93_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.2839,
    y1: 44.5243,
    x2: 23.3503,
    y2: 44.5243
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st92",
    d: "M22.4,44.9c-0.2-0.2-0.2-0.6,0-0.8c0.2-0.2,0.6-0.2,0.8,0c0.2,0.2,0.2,0.6,0,0.8C23,45.1,22.6,45.1,22.4,44.9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_94_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.2171,
    y1: 46.2648,
    x2: 23.2835,
    y2: 46.2648
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M22.4,46.6c-0.2-0.2-0.2-0.6,0-0.8c0.2-0.2,0.6-0.2,0.8,0c0.2,0.2,0.2,0.6,0,0.8 C22.9,46.9,22.6,46.9,22.4,46.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_95_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.6728,
    y1: 44.58,
    x2: 24.6471,
    y2: 44.58
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M23.8,44.9c-0.2-0.2-0.2-0.5,0-0.7s0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7C24.3,45.1,24,45.1,23.8,44.9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_96_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.5838,
    y1: 45.9825,
    x2: 24.558,
    y2: 45.9825
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M23.7,46.3c-0.2-0.2-0.2-0.5,0-0.7s0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7C24.2,46.5,23.9,46.5,23.7,46.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_97_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.0253,
    y1: 44.6762,
    x2: 25.8548,
    y2: 44.6762
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M25.1,45c-0.2-0.2-0.2-0.4,0-0.6c0.2-0.2,0.4-0.2,0.6,0c0.2,0.2,0.2,0.4,0,0.6C25.6,45.1,25.3,45.1,25.1,45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_98_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.9441,
    y1: 45.8116,
    x2: 25.7658,
    y2: 45.8116
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M25.1,46.1c-0.2-0.2-0.1-0.4,0-0.6c0.2-0.2,0.4-0.2,0.6,0s0.2,0.4,0,0.6C25.5,46.3,25.2,46.2,25.1,46.1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_99_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.2441,
    y1: 45.6486,
    x2: 26.9735,
    y2: 45.6486
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "M26.3,45.9c-0.1-0.2-0.1-0.4,0-0.5c0.2-0.1,0.4-0.1,0.5,0c0.1,0.2,0.1,0.4,0,0.5C26.7,46,26.5,46,26.3,45.9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_100_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.3554,
    y1: 44.7542,
    x2: 27.0848,
    y2: 44.7542
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M26.5,45c-0.1-0.2-0.1-0.4,0-0.5c0.2-0.1,0.4-0.1,0.5,0c0.1,0.2,0.1,0.4,0,0.5S26.6,45.1,26.5,45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_101_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.6633,
    y1: 45.5317,
    x2: 28.3149,
    y2: 45.5317
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M27.7,45.8c-0.1-0.1-0.1-0.3,0-0.5c0.1-0.1,0.3-0.1,0.5,0c0.1,0.1,0.1,0.3,0,0.4 C28.1,45.9,27.9,45.9,27.7,45.8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_102_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.2071,
    y1: 44.6868,
    x2: 29.7542,
    y2: 44.6868
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M29.3,44.9c-0.1-0.1-0.1-0.3,0-0.4c0.1-0.1,0.3-0.1,0.4,0c0.1,0.1,0.1,0.3,0,0.4C29.5,45,29.4,45,29.3,44.9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_103_",
    gradientUnits: "userSpaceOnUse",
    x1: 3.2713,
    y1: 44.019,
    x2: 3.8184,
    y2: 44.019
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M3.3,44.2c-0.1-0.1-0.1-0.3,0-0.4c0.1-0.1,0.3-0.1,0.4,0c0.1,0.1,0.1,0.3,0,0.4C3.6,44.3,3.5,44.3,3.3,44.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_104_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.1209,
    y1: 54.4156,
    x2: 6.668,
    y2: 54.4156
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M6.2,54.6c-0.1-0.1-0.1-0.3,0-0.4c0.1-0.1,0.3-0.1,0.4,0c0.1,0.1,0.1,0.3,0,0.4C6.5,54.7,6.3,54.7,6.2,54.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_105_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.5216,
    y1: 55.5777,
    x2: 7.0687,
    y2: 55.5777
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M6.6,55.8c-0.1-0.1-0.1-0.3,0-0.4c0.1-0.1,0.3-0.1,0.4,0c0.1,0.1,0.1,0.3,0,0.4C6.9,55.9,6.7,55.9,6.6,55.8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_106_",
    gradientUnits: "userSpaceOnUse",
    x1: 3.3158,
    y1: 43.0617,
    x2: 3.8629,
    y2: 43.0617
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M3.4,43.2c-0.1-0.1-0.1-0.3,0-0.4c0.1-0.1,0.3-0.1,0.4,0c0.1,0.1,0.1,0.3,0,0.4C3.7,43.4,3.5,43.4,3.4,43.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_107_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.029,
    y1: 45.4883,
    x2: 29.5761,
    y2: 45.4883
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M29.1,45.7c-0.1-0.1-0.1-0.3,0-0.4c0.1-0.1,0.3-0.1,0.4,0c0.1,0.1,0.1,0.3,0,0.4 C29.4,45.8,29.2,45.8,29.1,45.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_108_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.4955,
    y1: 45.5039,
    x2: 31.7181,
    y2: 45.5039
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M31.5,45.6c0,0,0-0.1,0-0.2s0.1,0,0.2,0c0,0,0,0.1,0,0.2C31.6,45.6,31.6,45.6,31.5,45.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_109_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.4547,
    y1: 45.0559,
    x2: 30.822,
    y2: 45.0559
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M30.5,45.2c-0.1-0.1-0.1-0.2,0-0.3s0.2-0.1,0.3,0c0.1,0.1,0.1,0.2,0,0.3C30.7,45.3,30.6,45.3,30.5,45.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_110_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.6692,
    y1: 43.965,
    x2: 2.0365,
    y2: 43.965
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M1.7,44.1c-0.1-0.1-0.1-0.2,0-0.3s0.2-0.1,0.3,0c0.1,0.1,0.1,0.2,0,0.3C1.9,44.2,1.8,44.2,1.7,44.1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_111_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.7137,
    y1: 43.3821,
    x2: 2.0811,
    y2: 43.3821
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st110",
    d: "M1.8,43.5c-0.1-0.1-0.1-0.2,0-0.3c0.1-0.1,0.2-0.1,0.3,0c0.1,0.1,0.1,0.2,0,0.3C1.9,43.6,1.8,43.6,1.8,43.5"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M5.1,56.4c-0.1-0.1-0.1-0.2,0-0.3c0.1-0.1,0.2-0.1,0.2,0s0.1,0.2,0,0.3C5.3,56.4,5.2,56.4,5.1,56.4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_112_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.3434,
    y1: 45.5456,
    x2: 30.7107,
    y2: 45.5456
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M30.4,45.7c-0.1-0.1-0.1-0.2,0-0.3s0.2-0.1,0.3,0c0.1,0.1,0.1,0.2,0,0.3C30.6,45.8,30.5,45.8,30.4,45.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_113_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.6988,
    y1: 36.7592,
    x2: 23.7288,
    y2: 36.7592
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st112",
    d: "M22.7,36.9c-0.1-0.3,0.1-0.6,0.4-0.6c0.3-0.1,0.6,0.1,0.6,0.4c0.1,0.3-0.1,0.6-0.4,0.6 C23,37.3,22.8,37.2,22.7,36.9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_114_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.1999,
    y1: 33.4382,
    x2: 18.2299,
    y2: 33.4382
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M17.2,33.6c-0.1-0.3,0.1-0.6,0.4-0.6c0.3-0.1,0.6,0.1,0.6,0.4s-0.1,0.6-0.4,0.6C17.5,34,17.3,33.8,17.2,33.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_115_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.3985,
    y1: 34.5552,
    x2: 17.4285,
    y2: 34.5552
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "st115",
    d: "M16.4,34.7c-0.1-0.3,0.1-0.6,0.4-0.6s0.6,0.1,0.6,0.4c0.1,0.3-0.1,0.6-0.4,0.6C16.7,35.1,16.5,35,16.4,34.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_116_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.2631,
    y1: 36.5366,
    x2: 16.2931,
    y2: 36.5366
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "st116",
    d: "M15.3,36.7c-0.1-0.3,0.1-0.6,0.4-0.6s0.6,0.1,0.6,0.4c0.1,0.3-0.1,0.6-0.4,0.6C15.6,37.1,15.3,36.9,15.3,36.7 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_117_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.6175,
    y1: 37.9798,
    x2: 15.6475,
    y2: 37.9798
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M14.6,38.1c-0.1-0.3,0.1-0.6,0.4-0.6s0.6,0.1,0.6,0.4c0.1,0.3-0.1,0.6-0.4,0.6C15,38.5,14.7,38.4,14.6,38.1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_118_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.2613,
    y1: 39.2704,
    x2: 15.2913,
    y2: 39.2704
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M14.3,39.4c-0.1-0.3,0.1-0.6,0.4-0.6c0.3-0.1,0.6,0.1,0.6,0.4c0.1,0.3-0.1,0.6-0.4,0.6 C14.6,39.8,14.3,39.7,14.3,39.4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_119_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.7192,
    y1: 37.9792,
    x2: 22.7492,
    y2: 37.9792
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "st119",
    d: "M21.7,38.1c-0.1-0.3,0.1-0.6,0.4-0.6c0.3-0.1,0.6,0.1,0.6,0.4c0.1,0.3-0.1,0.6-0.4,0.6 C22.1,38.5,21.8,38.4,21.7,38.1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_120_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.8955,
    y1: 39.4268,
    x2: 21.9255,
    y2: 39.4268
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "st120",
    d: "M20.9,39.5c-0.1-0.3,0.1-0.6,0.4-0.6c0.3-0.1,0.6,0.1,0.6,0.4c0.1,0.3-0.1,0.6-0.4,0.6 C21.2,40,21,39.8,20.9,39.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_121_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.1572,
    y1: 36.0384,
    x2: 22.5098,
    y2: 36.0384
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "M21.2,36.2c-0.1-0.4,0.1-0.7,0.5-0.8c0.4-0.1,0.7,0.1,0.8,0.5c0.1,0.4-0.1,0.7-0.5,0.8 C21.6,36.8,21.3,36.5,21.2,36.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_122_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.6656,
    y1: 35.0733,
    x2: 21.0405,
    y2: 35.0733
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "st122",
    d: "M19.7,35.2c-0.1-0.4,0.1-0.7,0.5-0.8c0.4-0.1,0.7,0.1,0.8,0.5c0.1,0.4-0.1,0.7-0.5,0.8 C20.1,35.8,19.8,35.6,19.7,35.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_123_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.3366,
    y1: 34.1611,
    x2: 19.5199,
    y2: 34.1611
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "M18.3,34.3c-0.1-0.3,0.1-0.6,0.4-0.7c0.3-0.1,0.6,0.1,0.7,0.4c0.1,0.3-0.1,0.6-0.4,0.7 C18.8,34.8,18.4,34.6,18.3,34.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_124_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.4461,
    y1: 35.341,
    x2: 18.6294,
    y2: 35.341
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M17.5,35.5c-0.1-0.3,0.1-0.6,0.4-0.7s0.6,0.1,0.7,0.4c0.1,0.3-0.1,0.6-0.4,0.7C17.9,36,17.5,35.8,17.5,35.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_125_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.7782,
    y1: 36.5877,
    x2: 17.9615,
    y2: 36.5877
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "M16.8,36.7c-0.1-0.3,0.1-0.6,0.4-0.7s0.6,0.1,0.7,0.4c0.1,0.3-0.1,0.6-0.4,0.7C17.2,37.2,16.9,37,16.8,36.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_126_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.1103,
    y1: 37.879,
    x2: 17.2937,
    y2: 37.879
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M16.1,38c-0.1-0.3,0.1-0.6,0.4-0.7s0.6,0.1,0.7,0.4c0.1,0.3-0.1,0.6-0.4,0.7C16.5,38.5,16.2,38.3,16.1,38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_127_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.6651,
    y1: 39.1702,
    x2: 16.8484,
    y2: 39.1702
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "M15.7,39.3c-0.1-0.3,0.1-0.6,0.4-0.7c0.3-0.1,0.6,0.1,0.7,0.4c0.1,0.3-0.1,0.6-0.4,0.7 C16.1,39.8,15.7,39.6,15.7,39.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_128_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.7751,
    y1: 36.2722,
    x2: 20.15,
    y2: 36.2722
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "st128",
    d: "M18.8,36.4c-0.1-0.4,0.1-0.7,0.5-0.8c0.4-0.1,0.7,0.1,0.8,0.5c0.1,0.4-0.1,0.7-0.5,0.8 C19.2,37,18.9,36.8,18.8,36.4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_129_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.9959,
    y1: 37.5857,
    x2: 19.3708,
    y2: 37.5857
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "st129",
    d: "M18,37.7c-0.1-0.4,0.1-0.7,0.5-0.8c0.4-0.1,0.7,0.1,0.8,0.5c0.1,0.4-0.1,0.7-0.5,0.8 C18.5,38.3,18.1,38.1,18,37.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_130_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.3948,
    y1: 39.0327,
    x2: 18.7697,
    y2: 39.0327
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "st130",
    d: "M17.4,39.2c-0.1-0.4,0.1-0.7,0.5-0.8c0.4-0.1,0.7,0.1,0.8,0.5c0.1,0.4-0.1,0.7-0.5,0.8 C17.9,39.8,17.5,39.5,17.4,39.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_131_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.0886,
    y1: 37.441,
    x2: 21.4412,
    y2: 37.441
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "M20.1,37.6c-0.1-0.4,0.1-0.7,0.5-0.8c0.4-0.1,0.7,0.1,0.8,0.5c0.1,0.4-0.1,0.7-0.5,0.8 C20.6,38.2,20.2,37.9,20.1,37.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_132_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.2204,
    y1: 39.0884,
    x2: 20.573,
    y2: 39.0884
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "st132",
    d: "M19.2,39.2c-0.1-0.4,0.1-0.7,0.5-0.8c0.4-0.1,0.7,0.1,0.8,0.5c0.1,0.4-0.1,0.7-0.5,0.8 C19.7,39.8,19.3,39.6,19.2,39.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_133_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.5842,
    y1: 40.8618,
    x2: 28.0378,
    y2: 40.8618
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "st133",
    d: "M27.6,40.9c0-0.1,0-0.2,0.2-0.3c0.1,0,0.2,0,0.3,0.2c0,0.1,0,0.2-0.2,0.3C27.7,41.1,27.6,41,27.6,40.9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_134_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.8941,
    y1: 40.1605,
    x2: 27.4145,
    y2: 40.1605
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M26.9,40.2c0-0.1,0-0.3,0.2-0.3c0.1,0,0.3,0,0.3,0.2c0,0.1,0,0.3-0.2,0.3C27.1,40.4,26.9,40.4,26.9,40.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_135_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.2427,
    y1: 39.5231,
    x2: 26.8413,
    y2: 39.5231
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "st135",
    d: "M26.3,39.6c0-0.2,0.1-0.3,0.2-0.4c0.2,0,0.3,0.1,0.4,0.2c0,0.2-0.1,0.3-0.2,0.4 C26.4,39.8,26.3,39.7,26.3,39.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_136_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.0001,
    y1: 32.1798,
    x2: 15.5988,
    y2: 32.1798
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "M15,32.2c0-0.2,0.1-0.3,0.2-0.4c0.2,0,0.3,0.1,0.4,0.2c0,0.2-0.1,0.3-0.2,0.4C15.2,32.5,15,32.4,15,32.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_137_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.8037,
    y1: 31.7007,
    x2: 14.3241,
    y2: 31.7007
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M13.8,31.8c0-0.1,0-0.3,0.2-0.3c0.1,0,0.3,0,0.3,0.2c0,0.1,0,0.3-0.2,0.3C14,32,13.8,31.9,13.8,31.8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_138_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.2249,
    y1: 32.5467,
    x2: 13.7453,
    y2: 32.5467
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "st138",
    d: "M13.2,32.6c0-0.1,0-0.3,0.2-0.3c0.1,0,0.3,0,0.3,0.2c0,0.1,0,0.3-0.2,0.3C13.4,32.8,13.3,32.7,13.2,32.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_139_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.2655,
    y1: 33.1816,
    x2: 14.8641,
    y2: 33.1816
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "st139",
    d: "M14.3,33.2c0-0.2,0.1-0.3,0.2-0.4c0.2,0,0.3,0.1,0.4,0.2c0,0.2-0.1,0.3-0.2,0.4 C14.5,33.5,14.3,33.4,14.3,33.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_140_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.9057,
    y1: 38.2987,
    x2: 12.5043,
    y2: 38.2987
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M11.9,38.4c0-0.2,0.1-0.3,0.2-0.4s0.3,0.1,0.4,0.2c0,0.2-0.1,0.3-0.2,0.4C12.1,38.6,12,38.5,11.9,38.4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_141_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.5272,
    y1: 39.7936,
    x2: 12.1258,
    y2: 39.7936
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "st141",
    d: "M11.5,39.9c0-0.2,0.1-0.3,0.2-0.4c0.2,0,0.3,0.1,0.4,0.2c0,0.2-0.1,0.3-0.2,0.4C11.7,40.1,11.6,40,11.5,39.9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_142_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.683,
    y1: 39.0779,
    x2: 12.2816,
    y2: 39.0779
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "st142",
    d: "M11.7,39.1c0-0.2,0.1-0.3,0.2-0.4c0.2,0,0.3,0.1,0.4,0.2s-0.1,0.3-0.2,0.4C11.9,39.4,11.7,39.3,11.7,39.1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_143_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.5082,
    y1: 38.9136,
    x2: 26.2178,
    y2: 38.9136
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "st143",
    d: "M25.5,39c0-0.2,0.1-0.4,0.3-0.4c0.2,0,0.4,0.1,0.4,0.3c0,0.2-0.1,0.4-0.3,0.4C25.8,39.3,25.6,39.2,25.5,39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_144_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.7747,
    y1: 38.2691,
    x2: 25.5265,
    y2: 38.2691
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "st144",
    d: "M24.8,38.3c0-0.2,0.1-0.4,0.3-0.4c0.2,0,0.4,0.1,0.4,0.3c0,0.2-0.1,0.4-0.3,0.4C25,38.7,24.8,38.6,24.8,38.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_145_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.1369,
    y1: 32.748,
    x2: 16.8887,
    y2: 32.748
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M16.1,32.8c0-0.2,0.1-0.4,0.3-0.4c0.2,0,0.4,0.1,0.4,0.3c0,0.2-0.1,0.4-0.3,0.4C16.4,33.2,16.2,33,16.1,32.8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_146_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.2909,
    y1: 33.9502,
    x2: 16.0427,
    y2: 33.9502
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M15.3,34c0-0.2,0.1-0.4,0.3-0.4c0.2,0,0.4,0.1,0.4,0.3c0,0.2-0.1,0.4-0.3,0.4C15.5,34.4,15.3,34.3,15.3,34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_147_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.5321,
    y1: 37.3335,
    x2: 14.284,
    y2: 37.3335
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "st147",
    d: "M13.5,37.4c0-0.2,0.1-0.4,0.3-0.4s0.4,0.1,0.4,0.3s-0.1,0.4-0.3,0.4S13.6,37.6,13.5,37.4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_148_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.1537,
    y1: 38.4215,
    x2: 13.9055,
    y2: 38.4215
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M13.2,38.5c0-0.2,0.1-0.4,0.3-0.4c0.2,0,0.4,0.1,0.4,0.3s-0.1,0.4-0.3,0.4C13.4,38.8,13.2,38.7,13.2,38.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_149_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.8643,
    y1: 39.5153,
    x2: 13.6161,
    y2: 39.5153
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M12.9,39.6c0-0.2,0.1-0.4,0.3-0.4c0.2,0,0.4,0.1,0.4,0.3c0,0.2-0.1,0.4-0.3,0.4 C13.1,39.9,12.9,39.8,12.9,39.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_150_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.7508,
    y1: 37.5522,
    x2: 24.6875,
    y2: 37.5522
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "st150",
    d: "M23.8,37.7c0-0.2,0.1-0.5,0.4-0.6c0.2-0.1,0.5,0.1,0.6,0.4c0.1,0.2-0.1,0.5-0.3,0.6 C24.1,38.1,23.8,37.9,23.8,37.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_151_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.9493,
    y1: 38.5318,
    x2: 23.886,
    y2: 38.5318
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "st151",
    d: "M23,38.6c0-0.2,0.1-0.5,0.4-0.6c0.2-0.1,0.5,0.1,0.6,0.4c0.1,0.2-0.1,0.5-0.3,0.6C23.3,39,23,38.9,23,38.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_152_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.1924,
    y1: 39.7562,
    x2: 23.1068,
    y2: 39.7562
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "M22.2,39.9c0-0.2,0.1-0.5,0.3-0.6c0.2-0.1,0.5,0.1,0.6,0.4c0.1,0.2-0.1,0.5-0.4,0.6 C22.5,40.3,22.3,40.1,22.2,39.9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_153_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.0178,
    y1: 39.1117,
    x2: 24.7696,
    y2: 39.1117
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M24,39.2c0-0.2,0.1-0.4,0.3-0.4c0.2,0,0.4,0.1,0.4,0.3c0,0.2-0.1,0.4-0.3,0.4C24.3,39.5,24.1,39.4,24,39.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_154_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.3722,
    y1: 40.1386,
    x2: 24.124,
    y2: 40.1386
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "st154",
    d: "M23.4,40.2c0-0.2,0.1-0.4,0.3-0.4c0.2,0,0.4,0.1,0.4,0.3c0,0.2-0.1,0.4-0.3,0.4 C23.6,40.6,23.4,40.4,23.4,40.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_155_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.8626,
    y1: 39.6043,
    x2: 25.5722,
    y2: 39.6043
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "st155",
    d: "M24.9,39.7c0-0.2,0.1-0.4,0.3-0.4c0.2,0,0.4,0.1,0.4,0.3c0,0.2-0.1,0.4-0.3,0.4S24.9,39.9,24.9,39.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_156_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.3283,
    y1: 40.428,
    x2: 25.0379,
    y2: 40.428
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "st156",
    d: "M24.3,40.5c0-0.2,0.1-0.4,0.3-0.4c0.2,0,0.4,0.1,0.4,0.3c0,0.2-0.1,0.4-0.3,0.4 C24.6,40.8,24.4,40.7,24.3,40.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_157_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.6639,
    y1: 40.106,
    x2: 26.2625,
    y2: 40.106
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M25.7,40.2c0-0.2,0.1-0.3,0.2-0.4c0.2,0,0.3,0.1,0.4,0.2c0,0.2-0.1,0.3-0.2,0.4 C25.9,40.4,25.7,40.4,25.7,40.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_158_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.2187,
    y1: 40.7731,
    x2: 25.8173,
    y2: 40.7731
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "st158",
    d: "M25.2,40.8c0-0.2,0.1-0.3,0.2-0.4c0.2,0,0.3,0.1,0.4,0.2c0,0.2-0.1,0.3-0.2,0.4C25.4,41.1,25.3,41,25.2,40.8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_159_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.0704,
    y1: 41.1182,
    x2: 26.5907,
    y2: 41.1182
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "st159",
    d: "M26.1,41.2c0-0.1,0-0.3,0.2-0.3c0.1,0,0.3,0,0.3,0.2c0,0.1,0,0.3-0.2,0.3C26.3,41.4,26.1,41.3,26.1,41.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_160_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.4711,
    y1: 40.6061,
    x2: 26.9915,
    y2: 40.6061
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "M26.5,40.7c0-0.1,0-0.3,0.2-0.3c0.1,0,0.3,0,0.3,0.2c0,0.1,0,0.3-0.2,0.3C26.6,40.9,26.5,40.8,26.5,40.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_161_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.9831,
    y1: 41.53,
    x2: 27.4368,
    y2: 41.53
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "st161",
    d: "M27,41.6c0-0.1,0-0.2,0.2-0.3c0.1,0,0.2,0,0.3,0.2c0,0.1,0,0.2-0.2,0.3C27.1,41.8,27,41.7,27,41.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_162_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.2297,
    y1: 41.5613,
    x2: 28.6167,
    y2: 41.5613
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "M28.2,41.6c0-0.1,0-0.2,0.2-0.2c0.1,0,0.2,0,0.2,0.2c0,0.1,0,0.2-0.2,0.2C28.4,41.8,28.3,41.7,28.2,41.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_163_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.312,
    y1: 31.8993,
    x2: 12.699,
    y2: 31.8993
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "st163",
    d: "M12.3,31.9c0-0.1,0-0.2,0.2-0.2c0.1,0,0.2,0,0.2,0.2c0,0.1,0,0.2-0.2,0.2C12.4,32.1,12.3,32,12.3,31.9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_164_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.3752,
    y1: 39.2481,
    x2: 10.7622,
    y2: 39.2481
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "st164",
    d: "M10.4,39.3c0-0.1,0-0.2,0.2-0.2s0.2,0,0.2,0.2s0,0.2-0.1,0.2C10.5,39.5,10.4,39.4,10.4,39.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_165_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.2193,
    y1: 40.1052,
    x2: 10.6064,
    y2: 40.1052
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "st165",
    d: "M10.2,40.1c0-0.1,0-0.2,0.2-0.2c0.1,0,0.2,0,0.2,0.1c0,0.1,0,0.2-0.1,0.2C10.4,40.3,10.2,40.2,10.2,40.1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_166_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.6682,
    y1: 31.3227,
    x2: 13.0552,
    y2: 31.3227
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "st166",
    d: "M12.7,31.4c0-0.1,0-0.2,0.2-0.2s0.2,0,0.2,0.2c0,0.1,0,0.2-0.2,0.2C12.8,31.5,12.7,31.5,12.7,31.4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_167_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.829,
    y1: 41.9843,
    x2: 28.216,
    y2: 41.9843
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "st167",
    d: "M27.8,42c0-0.1,0-0.2,0.2-0.2c0.1,0,0.2,0,0.2,0.2s0,0.2-0.2,0.2C28,42.2,27.9,42.1,27.8,42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_168_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.3694,
    y1: 42.8101,
    x2: 29.5252,
    y2: 42.8101
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "M29.4,42.8C29.4,42.8,29.4,42.7,29.4,42.8c0.1-0.1,0.2-0.1,0.2,0S29.5,42.9,29.4,42.8 C29.4,42.9,29.4,42.9,29.4,42.8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_169_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.5575,
    y1: 30.6577,
    x2: 10.7134,
    y2: 30.6577
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "st169",
    d: "M10.6,30.7C10.6,30.6,10.6,30.6,10.6,30.7c0.1-0.1,0.2-0.1,0.2,0C10.7,30.7,10.7,30.7,10.6,30.7 C10.6,30.8,10.6,30.7,10.6,30.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_170_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.0419,
    y1: 40.6284,
    x2: 8.1977,
    y2: 40.6284
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M8,40.6C8,40.6,8.1,40.6,8,40.6c0.1-0.1,0.2-0.1,0.2,0C8.2,40.7,8.2,40.7,8,40.6C8.1,40.7,8.1,40.7,8,40.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_171_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.8738,
    y1: 42.1868,
    x2: 29.1303,
    y2: 42.1868
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "M28.9,42.2c0-0.1,0-0.1,0.1-0.2c0.1,0,0.1,0,0.2,0.1c0,0.1,0,0.1-0.1,0.2C29,42.3,28.9,42.3,28.9,42.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_172_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.3532,
    y1: 31.2559,
    x2: 11.6097,
    y2: 31.2559
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "st172",
    d: "M11.4,31.3c0-0.1,0-0.1,0.1-0.2c0.1,0,0.1,0,0.2,0.1c0,0.1,0,0.1-0.1,0.2C11.4,31.4,11.4,31.4,11.4,31.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_173_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.5758,
    y1: 30.9219,
    x2: 11.8323,
    y2: 30.9219
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "st173",
    d: "M11.6,31c0-0.1,0-0.1,0.1-0.2c0.1,0,0.1,0,0.2,0.1c0,0.1,0,0.1-0.1,0.2C11.7,31.1,11.6,31,11.6,31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_174_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.1047,
    y1: 39.9383,
    x2: 9.3611,
    y2: 39.9383
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "st174",
    d: "M9.1,40c0-0.1,0-0.1,0.1-0.2s0.1,0,0.2,0.1c0,0.1,0,0.1-0.1,0.2S9.1,40,9.1,40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_175_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.0379,
    y1: 40.3835,
    x2: 9.2944,
    y2: 40.3835
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "M9,40.4c0-0.1,0-0.1,0.1-0.2s0.1,0,0.2,0.1c0,0.1,0,0.1-0.1,0.2C9.1,40.5,9.1,40.5,9,40.4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_176_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.6289,
    y1: 42.4375,
    x2: 28.8854,
    y2: 42.4375
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "st176",
    d: "M28.6,42.5c0-0.1,0-0.1,0.1-0.2c0.1,0,0.1,0,0.2,0.1c0,0.1,0,0.1-0.1,0.2C28.7,42.6,28.6,42.6,28.6,42.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_177_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.5234,
    y1: 32.5833,
    x2: 30.438,
    y2: 32.5833
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "st177",
    d: "M29.4,31.6c0,0-0.2,0.5-0.2,0.6l-0.7,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.4,0.3,0.5,0.4c0,0.2-0.1,0.7-0.1,0.7 v0h0l0.6-0.4c0.1,0.1,0.6,0.3,0.6,0.3s0,0,0,0v0L30,32.8l0.4-0.5l0,0l0,0c0,0,0,0,0,0c0,0-0.6,0-0.6,0 C29.7,32.1,29.5,31.6,29.4,31.6C29.5,31.6,29.4,31.6,29.4,31.6C29.4,31.6,29.4,31.6,29.4,31.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_178_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.7851,
    y1: 28.4458,
    x2: 27.6774,
    y2: 28.4458
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "st178",
    d: "M26.7,27.5c0,0-0.2,0.5-0.2,0.6l-0.7,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.4,0.3,0.5,0.4c0,0.2-0.1,0.7-0.1,0.7 v0c0,0,0,0,0,0l0.6-0.4c0.1,0.1,0.6,0.3,0.6,0.3s0,0,0,0v0l-0.2-0.6l0.4-0.5l0,0l0,0c0,0,0,0,0,0c0,0-0.6,0-0.6,0 C26.9,28,26.7,27.5,26.7,27.5C26.7,27.5,26.7,27.5,26.7,27.5C26.7,27.5,26.7,27.5,26.7,27.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_179_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.0246,
    y1: 24.2877,
    x2: 24.9169,
    y2: 24.2877
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M23.9,23.3c0,0-0.2,0.5-0.2,0.6L23,24.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.4,0.3,0.5,0.4c0,0.2-0.1,0.7-0.1,0.7 v0c0,0,0,0,0,0l0.6-0.4c0.1,0.1,0.6,0.3,0.6,0.3h0v0l-0.2-0.6l0.4-0.5l0,0l0,0c0,0,0,0,0,0c0,0-0.6,0-0.6,0 C24.2,23.8,24,23.3,23.9,23.3C24,23.3,24,23.3,23.9,23.3C24,23.3,23.9,23.3,23.9,23.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_180_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.776,
    y1: 19.7684,
    x2: 22.6461,
    y2: 19.7684
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "st180",
    d: "M21.7,18.8c0,0-0.2,0.5-0.2,0.6l-0.7,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.4,0.3,0.5,0.4c0,0.2-0.1,0.7-0.1,0.7 v0h0l0.6-0.4c0.1,0.1,0.6,0.3,0.6,0.3h0c0,0,0,0,0,0L22.2,20l0.4-0.5l0,0l0,0c0,0,0,0,0,0c0,0-0.6,0-0.6,0 C21.9,19.3,21.7,18.8,21.7,18.8C21.7,18.8,21.7,18.8,21.7,18.8L21.7,18.8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_181_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.9282,
    y1: 15.0487,
    x2: 20.8206,
    y2: 15.0487
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "st181",
    d: "M19.8,14.1c0,0-0.2,0.5-0.2,0.6L19,14.9c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.4,0.3,0.5,0.4c0,0.2-0.1,0.7-0.1,0.7 v0h0l0.6-0.4c0.1,0.1,0.6,0.3,0.6,0.3s0,0,0,0v0l-0.2-0.6l0.4-0.5l0,0l0,0c0,0,0,0,0,0c0,0-0.6,0-0.6,0 C20.1,14.6,19.9,14.1,19.8,14.1C19.9,14.1,19.9,14.1,19.8,14.1L19.8,14.1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_182_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.6815,
    y1: 10.2734,
    x2: 19.5961,
    y2: 10.2734
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "st182",
    d: "M18.6,9.3c0,0-0.2,0.5-0.2,0.6l-0.7,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.4,0.3,0.5,0.4c0,0.2-0.1,0.7-0.1,0.7 v0c0,0,0,0,0,0l0.6-0.4c0.1,0.1,0.6,0.3,0.6,0.3s0,0,0,0v0l-0.2-0.6l0.4-0.5l0,0l0,0c0,0,0,0,0,0c0,0-0.6,0-0.6,0 C18.9,9.8,18.6,9.3,18.6,9.3C18.6,9.3,18.6,9.3,18.6,9.3L18.6,9.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_183_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.1232,
    y1: 5.5677,
    x2: 18.0155,
    y2: 5.5677
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "st183",
    d: "M17,4.6c0,0-0.2,0.5-0.2,0.6l-0.7,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.4,0.3,0.5,0.4c0,0.2-0.1,0.7-0.1,0.7v0 c0,0,0,0,0,0l0.6-0.4c0.1,0.1,0.6,0.3,0.6,0.3h0v0l-0.2-0.6L18,5.3l0,0l0,0c0,0,0,0,0,0c0,0-0.6,0-0.6,0C17.3,5.1,17.1,4.6,17,4.6 C17.1,4.6,17.1,4.6,17,4.6C17,4.6,17,4.6,17,4.6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFederal);
export default __webpack_public_path__ + "static/media/federal.bce873aa2c3546d4ee4e0a07cbe85d5d.svg";
export { ForwardRef as ReactComponent };